// -> IAuditManager (AuditController). UC-14. GetEntryAsync 404s uniformly for "does not exist" and
// "exists but out of the caller's scope" (D-157) - a component must not treat a 404 here as proof
// the entry never existed.
import { http } from "./http";
import type { AuditEntry, AuditEntryDetail, PagedResult } from "./generated/contracts";

export interface AuditQueryParams {
  readonly actorPrincipalId?: string;
  readonly action?: string;
  readonly entityType?: string;
  readonly entityKey?: string;
  readonly teamCode?: string;
  readonly fromInclusiveUtc?: string;
  readonly toExclusiveUtc?: string;
  readonly pageNumber?: number;
  readonly pageSize?: number;
}

export const auditApi = {
  query: (params: AuditQueryParams = {}) => http.get<PagedResult<AuditEntry>>("/api/audit", { query: { ...params } }),

  getEntry: (entryKey: string) => http.get<AuditEntryDetail>(`/api/audit/${entryKey}`),

  getEntityHistory: (entityType: string, entityKey: string) =>
    http.get<AuditEntry[]>(`/api/audit/entities/${entityType}/${entityKey}`),
};
